import { TextArea as OriginalTextArea } from 'antd-mobile';
import { withNativeElementWrap } from '../../utils/hoc';
const TextArea = withNativeElementWrap(OriginalTextArea, ['clear']);
export default TextArea;
